import { v4 } from 'uuid';

import { RecordData } from '../../helpers-classes';
import { ItemData, ItemDataIn } from './types';

export const itemData = (dataIn: ItemDataIn = null): ItemData => {
	const rd = new RecordData<ItemDataIn>(dataIn);

	const record: ItemData = {
		id: rd.useNewOrPartial<string>('id', v4()),
		exclude: rd.useNewOrDefault<boolean>('exclude', false),
		override: rd.useNewOrDefault<boolean>('override', false),
		component: rd.useNewOrDefault<ItemData['component'] | null>('component', null),
		fuelchoice: rd.useNewOrDefault<string | null>('fuelchoice', null),
		skuColor: rd.useNewOrDefault<string | null>('skuColor', null),
		// Per-placed-item landing-zone override; null inherits the catalog's component.landingZone (#340).
		landingZoneOverride: rd.useNewOrDefault<boolean | null>('landingZoneOverride', null)
	}

	return record;
};
